module.exports = __webpack_public_path__ + "img/search1.03928782.png";